'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var is_object = require('./is_object.js');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

function writeToDom(key, val) {
    document.body.style.setProperty("--" + key, val);
}
function setStyle(style, path) {
    if (path === void 0) { path = []; }
    for (var styleProp in style) {
        if (!Object.prototype.hasOwnProperty.call(style, styleProp)) {
            continue;
        }
        var val = style[styleProp];
        var newPath = __spreadArray(__spreadArray([], path), [styleProp]);
        if (is_object['default'](val)) {
            setStyle(val, newPath);
            return;
        }
        // noinspection SuspiciousTypeOfGuard
        if (val && typeof val === 'string') {
            writeToDom(newPath.join('-'), val);
        }
    }
}
var Style = /** @class */ (function () {
    function Style() {
    }
    Style.applyStyle = function (style) {
        setStyle(style);
    };
    Style.getCustomProperty = function (key) {
        var styles = window.getComputedStyle(document.body);
        return styles.getPropertyValue("--" + key);
    };
    Style.setFavicon = function () {
        var link = document.querySelector('link[rel~=\'icon\']');
        if (!link) {
            link = document.createElement('link');
            link.setAttribute('rel', 'icon');
            document.head.appendChild(link);
        }
        var img = document.createElement('img');
        var faviconUrl = link.href || window.location.origin + "/favicon.ico";
        var onImageLoaded = function () {
            var canvas = document.createElement('canvas');
            canvas.width = 32;
            canvas.height = 32;
            var context = canvas.getContext('2d');
            context.drawImage(img, 0, 0);
            context.globalCompositeOperation = 'xor';
            context.fillStyle = Style.getCustomProperty('color-secondary');
            context.fillRect(0, 0, 32, 32);
            context.fill();
            link.type = 'image/x-icon';
            link.href = canvas.toDataURL();
        };
        img.addEventListener('load', onImageLoaded);
        img.src = faviconUrl;
    };
    return Style;
}());

exports.default = Style;
//# sourceMappingURL=style.js.map
